import {
  EventTypes,
  track,
  getPageSource,
  PageSourceType,
} from '@mc/track-event'

export const trackValuePropViewed = ({
  pageSource,
}: {
  pageSource?: PageSourceType
} = {}) => {
  track(EventTypes.VALUE_PROP_VIEWED, {
    page_source: pageSource || getPageSource(),
  })
}
